import { api } from '../../../services/api';
import {history} from '../../../helpers/history'
import toast from 'react-hot-toast';
const Logout =async  (reload=true) => {

    const res = await api.get('/logout/')

    if (res.status === 200)
    {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('user_id');
        localStorage.removeItem('grupo');
        localStorage.removeItem('hash');
        localStorage.removeItem('oid_enterprise')
        localStorage.removeItem('file_size')
        if (reload){
             history.navigate('/login')
            toast.success('Deslogado com sucesso!')
        }
    return
    }
    toast.error('Falha ao deslogar')
}


export default Logout